import { load } from '@/utils/utils'
import Store from '@/store'
import Router from '@/router'

export const AuthInterceptor = config => {
  const accessToken = load('AUTH_TOKEN', '')

  config.headers.common['Authorization'] = `Bearer ${accessToken}`

  return config
}

export const UnauthorizedInterceptor = async err => {
  if (err.response && err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
    // temporary solution until refresh tokens are available
    await Store.dispatch('auth/logout', { skipRequest: true })
    Router.push({ name: 'login', query: { redirect: window.location.pathname } })
    return Promise.reject(err)
  }

  return Promise.reject(err)
}
